import React from "react";
import { CgLoadbar } from "react-icons/cg";
import { FaGithub, FaLinkedin, FaFilePdf } from "react-icons/fa";
import { openInNewTab } from "./Helper/helper";
import cvFile from "./Files/cv.pdf";

export default function Navbar() {
    //https://i.pinimg.com/originals/2f/aa/00/2faa00db1eadd32f9c32b5e4af56e61b.jpg

    return (
        <div className="flex flex-col lg:flex-row items-center pb-6 pt-2">
            <div className="flex-1 text-center text-lg lg:text-left font-sourcecodepro">
                jack king
            </div>
            <div className="flex-1 flex items-center">
                <div id="menunav" className="w-full ">
                    <ul className="flex h-full justify-center lg:justify-end ">
                        <li
                            onClick={() => openInNewTab(cvFile)}
                            className="p-1 mr-2 hover:cursor-pointer group items-center flex gap-1"
                        >
                            <FaFilePdf />
                            cv
                        </li>
                        <li
                            onClick={() =>
                                openInNewTab("https://github.com/jack-king1")
                            }
                            className="p-1 mr-2 hover:cursor-pointer group items-center flex gap-1"
                        >
                            <FaGithub />
                            <div>github</div>
                        </li>
                        <li
                            onClick={() =>
                                openInNewTab(
                                    "https://www.linkedin.com/in/jackking1/"
                                )
                            }
                            className="p-1 mr-2 hover:cursor-pointer group items-center flex gap-1"
                        >
                            <FaLinkedin />
                            <div>linkedin</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
